import appStore from 'store'
import api from './api'
import { STATUS_TYPE, PAGINATION } from './constants'

const store = {
  namespaced: true,
  state: {
    otcAuditList: [],
    detailDialogVisible: false,
    pagination: PAGINATION,
    totalCount: 0,
  },
  getters: {
    otcAuditList: (state) =>
      state.otcAuditList.map((item) => {
        return {
          ...item,
          __status: STATUS_TYPE[item.status],
        }
      }),
  },
  mutations: {
    setOtcAuditList(state, payload) {
      state.otcAuditList = payload.items
      state.totalCount = payload.total
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    toggleDetailDialogVisible(state, payload) {
      state.detailDialogVisible = payload
    },
  },
  actions: {
    list({ commit }, query) {
      // eslint-disable-line
      commit('setPagination', { page: query.page, size: query.size })
      api.getOtcAuditList(query).then(({ data }) => {
        commit('setOtcAuditList', data)
      })
    },
  },
}

appStore.registerModule('otcAudit', store)
